import React, { useEffect, useState } from "react";
import RecruitmentServices from "../../../src/Services/RecruitmentServices";
var RecruitmentServicesObj = new RecruitmentServices();
import Swal from "sweetalert2";

const ApplyOppourtunities = ({ text }) => {
  console.log(text, "text");
  const [isLoaded, setIsLoaded] = useState(false);
  const [applyFormDetails, setApplyFormDetails] = useState(false);

  const onSubmit = async (data) => {
    data.preventDefault();
    const jobName = text;
    var data = {
      firstName: document.getElementById("firstName").value.trim(),
      lastName: document.getElementById("lastName").value.trim(),
      email: document.getElementById("email").value.trim(),
      phoneNumber: document.getElementById("contactNumber").value.trim(),
      resumePath: document.getElementById("resumePath").value.trim(),
      city: document.getElementById("city").value.trim(),
      eligibleToUS: applyFormDetails.eligibleToUS ?? -1,
      sponsershipToWorkUS: applyFormDetails.sponsershipToWorkUS ?? -1,
      jobName: jobName,
    };

    console.log(JSON.stringify(data));

    let isValid = true;
    let isEmailValid = true;

    const setErrorState = (elementId, hasError) => {
      const element = document.getElementById(elementId);
      if (element) {
        if (hasError) {
          element.style.border = "1px solid #dd3535";
          isValid = false;
        } else {
          element.style.border = "";
        }
      } else {
        console.error(`Element with ID '${elementId}' not found`);
      }
    };

    setErrorState("firstName", data.firstName === "");
    setErrorState("lastName", data.lastName === "");
    setErrorState("email", data.email === "");
    setErrorState("contactNumber", data.phoneNumber === "");
    setErrorState("resumePath", data.resumePath === "");
    setErrorState("city", data.city === "");
    var emailcheck = !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
      data.email
    );
    if (emailcheck) {
      isEmailValid = false;
      Swal.fire({
        icon: "warning",
        title: "Enter valid email address",
        position: "top-end",
        toast: true,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          container: "custom-swal-container",
        },
      });
    }
    var ResumePath;
    if (isValid && isEmailValid) {
      setIsLoaded(true);
      const formData = new FormData();
      $.each($("#resumePath")[0].files, function (i, file) {
        formData.append("Resume", file);
      });
      await RecruitmentServicesObj.UploadResume(formData).then(async (res) => {
        debugger;
        ResumePath = res.data;
        data.resumePath = ResumePath;
        await RecruitmentServicesObj.Create(data).then(async (responce) => {
          if (responce.data === 1) {
            setTimeout(() => {
              $("#oppourtunitiesModelClsBtn").click();
            }, 1000);

            setIsLoaded(false);

            Swal.fire({
              icon: "success",
              title: "Apply Successfully",
              position: "top-end",
              toast: true,
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              customClass: {
                container: "custom-swal-container",
              },
            });
          } else if (responce.data === 0) {
            setTimeout(() => {
              $("#oppourtunitiesModelClsBtn").click();
            }, 1000);
            Swal.fire({
              icon: "error",
              title: "Something went wrong",
              position: "top-end",
              toast: true,
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              customClass: {
                container: "custom-swal-container",
              },
            });
            setIsLoaded(false);
          }
        });
      });
    } else if (!isValid) {
      Swal.fire({
        icon: "error",
        title: "Please fill the mandatory fields",
        position: "top-end",
        toast: true,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          container: "custom-swal-container",
        },
      });
    }
  };

  $("#oppourtunitiesModelClsBtn").click(function () {
    $("#sf")[0].reset();
    const textFields = $("#sf").find(
      'input[type="text"], input[type="email"],input[type="file"] ,textarea'
    );
    textFields.each(function () {
      $(this).css("border", "");
    });
  });

  const Closebtn = () => {
    debugger;
    $("#sf")[0].reset();
    const textFields = $("#sf").find(
      'input[type="text"], input[type="email"],input[type="file"] ,textarea'
    );
    textFields.each(function () {
      $(this).css("border", "");
    });
    $("#oppourtunitiesModelClsBtn").click();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setApplyFormDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function firstNameChange() {
    var FirstName = $("#firstName").val();
    if (FirstName == "") {
      document.getElementById("firstName").style.border = "1px solid #dd3535";
    } else {
      document.getElementById("firstName").style.border = "";
    }
  }
  function lastNameChange() {
    var FirstName = $("#lastName").val();
    if (FirstName == "") {
      document.getElementById("lastName").style.border = "1px solid #dd3535";
    } else {
      document.getElementById("lastName").style.border = "";
    }
  }

  function CheckEmailChange() {
    var email = $("#email").val();
    if (email === "") {
      document.getElementById("email").style.border = "1px solid #dd3535";
    } else {
      document.getElementById("email").style.border = "";
    }
  }
  function CantactNumberChange(e) {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/[^\d]/g, "");
    e.target.value = sanitizedValue;
  }
  function ContactNumber() {
    var FirstName = $("#contactNumber").val();
    if (FirstName == "") {
      document.getElementById("contactNumber").style.border =
        "1px solid #dd3535";
    } else {
      document.getElementById("contactNumber").style.border = "";
    }
  }
  function cityChange() {
    var cityName = $("#city").val();
    if (cityName == "") {
      document.getElementById("city").style.border = "1px solid #dd3535";
    } else {
      document.getElementById("city").style.border = "";
    }
  }
  const ResumeChange = (e) => {
    debugger;
    const checkPDF = e.target.files[0];

    if (checkPDF) {
      const fileName = checkPDF.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();

      if (fileExtension !== "pdf") {
        Swal.fire({
          icon: "warning",
          title: "Please upload a PDF formated file.",
          position: "top-end",
          toast: true,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            container: "custom-swal-container",
          },
        });
        e.target.value = "";
      } else {
        document.getElementById("resumePath").style.border = "";
      }
    }
  };
  const handleEligibleChange = (e) => {
    debugger;
    const { id } = e.target;
    let value = 0;

    if (id === "Yes") {
      value = 1;

      document.getElementById("No").checked = false;
    } else {
      document.getElementById("Yes").checked = false;
    }

    setApplyFormDetails((prevState) => ({
      ...prevState,
      eligibleToUS: value,
    }));
  };
  const handlesponsershipToWorkUSChange = (e) => {
    debugger;
    const { id } = e.target;
    let value = 0;

    if (id === "1") {
      value = 1;

      document.getElementById("0").checked = false;
    } else {
      document.getElementById("1").checked = false;
    }

    setApplyFormDetails((prevState) => ({
      ...prevState,
      sponsershipToWorkUS: value,
    }));
  };

  return (
    <>
      <section className="contact-area">
        <div className="row  fadeInUp">
          <form
            onSubmit={onSubmit}
            className="contact-form"
            autoComplete="off"
            id="sf"
          >
            <div className="col-md-12">
              <div className="contact-form">
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>
                      First Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      className="form-control"
                      id="firstName"
                      onBlur={firstNameChange}
                      onChange={handleChange}
                    />
                    <span className="text-danger"></span>
                  </div>
                  <div className="form-group col-md-6">
                    <label>
                      Last Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      className="form-control"
                      id="lastName"
                      onChange={handleChange}
                      onBlur={lastNameChange}
                    />
                    <span className="text-danger"></span>
                  </div>
                  <div className="form-group col-md-6">
                    <label>
                      Email<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="email"
                      className="form-control"
                      id="email"
                      onChange={handleChange}
                      onBlur={CheckEmailChange}
                    />
                    <span className="text-danger"> </span>
                  </div>
                  <div className="form-group col-md-6">
                    <label>
                      Phone Number
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="contactNumber"
                      className="form-control"
                      id="contactNumber"
                      maxLength={13}
                      onBlur={ContactNumber}
                      onChange={handleChange}
                      onInput={CantactNumberChange}
                    />
                    <span className="text-danger"></span>
                  </div>
                  <div className="form-group col-md-6">
                    <label>
                      Location(city)<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      id="city"
                      onChange={handleChange}
                      onBlur={cityChange}
                    />
                    <span className="text-danger"> </span>
                  </div>

                  <div className="form-group col-md-6">
                    <label>
                      Resume<small className="text-muted">(PDF only)</small>
                      <span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      type="file"
                      name="resumePath"
                      accept=".pdf"
                      className="form-control"
                      id="resumePath"
                      onChange={ResumeChange}
                      style={{ paddingTop: "10px", paddingLeft: "10px" }}
                    />
                    <span className="text-danger"></span>
                  </div>
                  <div className="form-group col-md-6">
                    <label>
                      Are you Eligible to work in the United States ?{" "}
                    </label>
                    <div className="form-check radiooption">
                      <div>
                        <label htmlFor="Yes" className="radio-inline">
                          <input
                            type="radio"
                            id="Yes"
                            name="eligibleForH1BMaster"
                            onChange={handleEligibleChange}
                          />
                          Yes
                        </label>
                        <label htmlFor="No" className="radio-inline">
                          <input
                            type="radio"
                            id="No"
                            name="eligibleForH1BMaster"
                            onChange={handleEligibleChange}
                          />
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>
                      Will you now, or in the future, require sponsorship to
                      work in the United States?{" "}
                    </label>
                    <div className="form-check radiooption">
                      <div>
                        <label htmlFor="Yes" className="radio-inline">
                          <input
                            type="radio"
                            id="1"
                            name="sponsershipToWorkUS"
                            onChange={handlesponsershipToWorkUSChange}
                          />
                          Yes
                        </label>
                        <label htmlFor="No" className="radio-inline">
                          <input
                            type="radio"
                            id="0"
                            name="sponsershipToWorkUS"
                            onChange={handlesponsershipToWorkUSChange}
                          />
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="button" onClick={Closebtn}>
                      Cancel
                    </button>
                    {!isLoaded ? (
                      <button
                        style={{ marginLeft: "10px" }}
                        type="submit"
                        name="submit"
                        id="submit"
                      >
                        Apply
                      </button>
                    ) : (
                      <button
                        type="button"
                        style={{ marginLeft: "10px" }}
                        disabled
                      >
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};
export default ApplyOppourtunities;
